import { type SafeHtml } from 'kerfjs';

import { StatusBadge } from './status-badge.js';

const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  submitted: 'Submitted',
  quoting: 'Quoting',
  analysed: 'Analysed',
  decided: 'Decided',
  closed: 'Closed',
  rejected: 'Rejected',
  returned: 'Returned',
  cancelled: 'Cancelled',
};

export function StatusChip({ status }: { status: string }): SafeHtml {
  return <StatusBadge status={status} label={STATUS_LABELS[status] ?? status} />;
}
